import { render } from "./LoginForm.vue?vue&type=template&id=150bc215"
import script from "./js/loginForm.js?vue&type=script&lang=js&external"
export * from "./js/loginForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__